export const contactsData = {
    email: 'sandiabhilash@gmail.com',
    phone: '+15713561405',
    address: 'Dallas, Texas, United States - 75068',

    sheetAPI: 'https://sheetdb.io/api/v1/rqrezr0o9eigy'
}